import firebase from 'firebase/app';
import 'firebase/storage';

const cache = {};
const storage = firebase.storage();

const getDownloadURL = ((path) => {
  // Create a reference with an initial file path and name
  if (!path.includes('/') || path.includes('..')) {
    // console.log(`image is not real ${path}`)
    return Promise.resolve(null);
  }
  const pathReference = storage.ref(path);
  if (cache[path]) {
    // console.log("returning from cache");
    console.log(cache[path]);
    return Promise.resolve(cache[path]);
  }
  // console.log("getting url for path", path);
  return pathReference.getDownloadURL().then((url) => {
    cache[path] = url;
    return url;
  });
});

const uploadFile = (file, path) => storage.ref().child(path).put(file);

export default {
  getDownloadURL,
  uploadFile,
};
